<template>
    <v-card
      dark
      class="primary darken-1"
      height="327"
      :width="width"
      :min-width="minWidth"
      style="border-radius: 5px; overflow-y: auto"
    >
      <v-expand-transition>
        <div
          v-if="erosion"
          class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal"
        >
          <v-card-text class="secondary--text text--lighten-1 text-justify">
            <v-row>
              <v-col cols="6">
                <v-icon large color="secondary lighten-1" @click="toggleErosion"
                  >mdi-arrow-left-circle</v-icon
                >
              </v-col>
              <v-spacer />
              <v-col cols="6" align-self="end" align="end">
                <v-icon large color="secondary lighten-1"> $erosion</v-icon>
              </v-col>
            </v-row>
            <br />
            {{ erosionText }}
          </v-card-text>
        </div>
      </v-expand-transition>
      <div v-if="!erosion">
        <v-card-subtitle class="white--text text--white">
          <span class="textDate"
            ><v-icon small>restore</v-icon> atualizado em</span
          ><br />
          <span class="textDate">{{ dateUpdate }}</span>
        </v-card-subtitle>
        <v-card-title>
          <v-icon class="ml-n1" color="secondary lighten-1" large>
            $erosion
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="white--text text--white">
          <strong class="textTitle">Erosão</strong>
          <v-tooltip right color="#1A232F">
            <template v-slot:activator="{on, attrs}">
              <v-icon
                class="ml-1"
                color="secondary lighten-1"
                v-bind="attrs"
                v-on="on"
                @click="toggleErosion"
              >
                help_outline
              </v-icon>
            </template>
            <span>Clique para informações</span>
          </v-tooltip>
        </v-card-subtitle>
        <v-card-text class="white--text text--white">
          <v-row no-gutters>
            <CardErosionChart></CardErosionChart>
          </v-row>
        </v-card-text>
      </div>
    </v-card>
</template>

<script>
import CardErosionChart from '@/components/indicators/IndicatorsCardsItems/CardErosionChart';

export default {
  name: 'CardErosion',
  props: {
    minWidth: {
      required: false,
    },
    width: {
      required: false,
    }
  },

  components: {CardErosionChart},

  data() {
    return {
      erosion: false,
      erosionText:
        'Foram levantadas informações sobre processos erosivos no estado do Paraná e, consequentemente, nas bacias hidrográficas monitoradas. As informações associadas aos processos erosivos estão separadas em 3 componentes: (i) Erodibilidade; (ii) Suscetibilidade à Erosão; (iii) Vulnerabilidade à Erosão. A erodibilidade considera as propriedades físicas intrínsecas ao solo (granulometria, estrutura), foi gerada a partir de interpretação pedológica, e expressa a capacidade do solo de resistir à erosão hídrica. A suscetibilidade à erosão é fundamentada na sobreposição dos mapas de erodibilidade, de erosividade (potencial da chuva em causar erosão) e da declividade do terreno. A Vulnerabilidade à erosão caracteriza o grau de vulnerabilidade dos solos aos processos erosivos, levando em consideração a suscetibilidade do solo à erosão aliada à cobertura vegetal natural e/ou o uso agropecuário, representando a soma dos mapas de suscetibilidade com o uso e cobertura da terra.',
    };
  },

  computed: {
    dateUpdate() {
      let date = null;
      this.$store.getters.indicator.forEach((el) => {
        if (el.indicador == 'erosao') {
          date = el.params.data_dado;
        }
      });

      return date;
    },
  },
  methods: {
    toggleErosion() {
      this.erosion = !this.erosion;
    },
  },
};
</script>

<style scoped>
.textDate {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}
.textTitle {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
}

.textBovines {
  font-family: 'Roboto';
  font-style: Regular;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
}
.textTotalBovines {
  font-family: 'Roboto';
  font-style: Bold;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #ffffff;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
